import GoInstall from "../../../../contents/docs/integrate/_snippets/install-go.mdx";
import GoSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-go.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import GoFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-go.mdx";
import LocalEvaluationIntro from "../../../../contents/docs/feature-flags/snippets/local-evaluation-intro.mdx";
import * as React from 'react';
export default {
  GoInstall,
  GoSendEvents,
  FeatureFlagsLibsIntro,
  GoFeatureFlagsCode,
  LocalEvaluationIntro,
  React
};